import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  OPEN_WINNER_DETAIL_MODAL: null,
  CLOSE_WINNER_DETAIL_MODAL: null,
});

export const openWinnerDetailModal = winnerId => ({
  type: Types.OPEN_WINNER_DETAIL_MODAL,
  winnerId
});

export const closeWinnerDetailModal = () => ({
  type: Types.CLOSE_WINNER_DETAIL_MODAL
});



// WEBPACK FOOTER //
// ./public/components/WinnerDetailModal/actions.js